<template lang="html">
  <section class="contenedor-perfil" :style="styles.backgroundWhite">

    <template v-if="!!perfil">



      <h2 class="ficha-title -big" :style="styles.colorBasic">{{$t('mi_perfil')}}</h2>

      <div class="contenedor-datos-perfil row-start ais">

        <h4 class="epigrafe" :style="styles.colorBasic">{{$t('datos_personales_contacto')}}</h4>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('nombre')}}</h4>
          <p>{{(!!perfil.nombre) ? perfil.nombre : $t('sin_introducir')}}</p>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('apellidos')}}</h4>
          <p>{{(!!perfil.apellidos) ? perfil.apellidos : $t('sin_introducir')}}</p>
        </div>


        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_nacimiento')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">{{(!!perfil.fechaNacimiento) ? perfil.fechaNacimiento : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit && !!perfil">
            <datepicker v-model="perfil.fechaNacimiento" :language="es" :full-month-name="true" v-validate="'required'"
              :monday-first="true" :format="'dd MMMM yyyy'" name="fechaNacimiento" :open-date="new Date()"
              :minimum-view="'day'"></datepicker>
            <span :class="['error',{'animated shake' : clicked}]"
              v-if="clicked">{{ errors.first('fechaNacimiento') }}</span>
          </div>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('dni')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">{{(!!perfil.dni) ? perfil.dni : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit">
            <input type="text" name="dni" :style="styles.input_black" v-model="perfil.dni"
              v-validate="'required|checkDNI'">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('dni') }}</span>
          </div>

        </div>


        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('email')}}</h4>
          <p>{{(!!perfil.email) ? perfil.email : $t('sin_introducir')}}</p>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('email_personal')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">{{(!!perfil.emailPersonal) ? perfil.emailPersonal : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit">
            <input type="text" name="emailpersonal" v-validate="'required|email'" :style="styles.input_black"
              v-model="perfil.emailPersonal">
            <span :class="['error',{'animated shake' : clicked}]"
              v-if="clicked">{{ errors.first('emailpersonal') }}</span>
          </div>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('telefono_profesional')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">{{(!!perfil.telefonoProfesional) ? perfil.telefonoProfesional : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit">
            <input type="text" :style="styles.input_black" v-model="perfil.telefonoProfesional"
              name="telefonoProfesional" v-validate="'required|min:9'">
            <span :class="['error',{'animated shake' : clicked}]"
              v-if="clicked">{{ errors.first('telefonoProfesional') }}</span>
          </div>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('telefono_movil')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">{{(!!perfil.movil) ? perfil.movil : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit">
            <input type="text" :style="styles.input_black" v-model="perfil.movil" name="movil" v-validate="'required|length:9'">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('movil') }}</span>
          </div>
        </div>

        <h4 class="epigrafe" :style="styles.colorBasic">{{$t('datos_profesionales')}}</h4>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('tipo')}}</h4>
          <p>{{(!!perfil.tipo) ? perfil.tipo : $t('sin_introducir')}}</p>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('area')}}</h4>
          <p>{{(!!perfil.area) ? perfil.area : $t('sin_introducir')}}</p>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('departamento')}}</h4>
          <p>{{(!!perfil.departamento) ? perfil.departamento : $t('sin_introducir')}}</p>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('cargo')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">{{(!!perfil.cargo) ? perfil.cargo : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit">
            <input type="text" name="cargo" v-validate="'required|min:3|alpha_spaces'" :style="styles.input_black" v-model="perfil.cargo">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('cargo') }}</span>
          </div>
        </div>





        <h4 class="epigrafe" :style="styles.colorBasic">{{$t('datos_facturacion')}}</h4>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('pais')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">{{(!!perfil.pais) ? perfil.pais : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit">
            <select name="pais" v-model="perfil.idPais" v-validate="'required'" @change="setProvincia"
              :style="styles.input_black">
              <option value="">{{$t('selecciona_pais')}}</option>
              <option v-if="!!dominiosOrder" v-for="(el, key) in dominiosOrder.paises" :value="Number(el[0])">{{el[1]}}
              </option>
            </select>
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('pais') }}</span>
          </div>
        </div>


        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('provincia')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">
            <template v-if="!!perfil.provincia || !!perfil.idProvincia">
              {{(!!perfil.idProvincia) ? dominios.provincias[perfil.idProvincia] : perfil.provincia}}
            </template>
            <template v-else>
              $t('sin_introducir')
            </template>
          </p>
          <div class="contenedor-input" v-if="edit">
            <select name="provincia" v-model="perfil.idProvincia" v-validate="'required'" v-if="perfil.idPais == 1"
              :style="styles.input_black">
              <option value="">$t('selecciona_provincia')</option>
              <option v-if="!!dominiosOrder" v-for="(el, key) in dominiosOrder.provincias" :value="Number(el[0])">
                {{el[1]}}
              </option>
            </select>
            <input type="text" name="provincia" :style="styles.input_black" v-validate="'required'"
              v-model="perfil.provincia" v-else>
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('provincia') }}</span>
          </div>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('localidad')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">
            <template v-if="!!perfil.localidad || !!perfil.idLocalidad">

              <template v-if="(!!perfil.idLocalidad)">
                <template
                  v-if="getLocalidad(perfil.idLocalidad)">{{getLocalidad(perfil.idLocalidad).descripcion}}</template>
              </template>
              <template v-else>
                {{perfil.localidad}}
              </template>
            </template>
            <template v-else>
              {{$t('sin_introducir')}}
            </template>
          </p>

          <div class="contenedor-input" v-if="edit">

            <predictivo :options="localidadesfilter(perfil.idProvincia)" v-model="perfil.idLocalidad" name="localidad"
              :likeSelect="true" :alwaysFind="true" v-if="perfil.idPais == 1" :keyid="'idLocalidad'" ref="localidad"
              :searchIn="'descripcion'" :preselected="perfil.localidad" v-validate="'required'"
              :style="styles.input_black">
            </predictivo>

            <input type="text" name="localidad" :style="styles.input_black" v-validate="'required'"
              v-model="perfil.localidad" v-else>
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('localidad') }}</span>
          </div>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('cp')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">{{(!!perfil.cp) ? perfil.cp : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit">
            <input type="text" name="cp" :style="styles.input_black" v-model="perfil.cp" v-validate="'required|min:5'">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('cp') }}</span>
          </div>
        </div>




        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('direccion_fiscal')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">{{(!!perfil.direccionFiscal) ? perfil.direccionFiscal : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit">
            <input type="text" name="direccionFiscal" :style="styles.input_black" v-validate="'required'"
              v-model="perfil.direccionFiscal">
            <span :class="['error',{'animated shake' : clicked}]"
              v-if="clicked">{{ errors.first('direccionFiscal') }}</span>
          </div>
        </div>






        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('numero_cuenta')}}<span v-if="edit">{{(totales.numTutoradosOevaluacionAsignadas  != 0) ? '*' : ''}}</span></h4>
          <p v-if="!edit">{{(!!perfil.iban) ? perfil.iban : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit">
            <input type="text" name="iban" :style="styles.input_black" v-model="perfil.iban"
              v-validate="(totales.numTutoradosOevaluacionAsignadas  != 0) ? 'required|checkiban' : ''" @keyup="quitarEspacios">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('iban') }}</span>
          </div>
        </div>

        <div class="contenedor-botones">
          <a class="btn" v-if="!edit" :style="styles.solidPrimary" @click="edit= true">{{$t('editar_datos')}}</a>
          <a class="btn" v-if="edit" :style="styles.solidPrimary" @click="savedata" :loading="loading">{{$t('guardar_datos')}}</a>

          <p class="explain">{{$t('si_datos_erroneos')}}</p>

        </div>
      </div>

    </template>

    <loading v-else></loading>


  </section>
</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import Datepicker from 'vuejs-datepicker';

  import { es } from 'vuejs-datepicker/dist/locale'

  import { Validator } from 'vee-validate';

  import loading from '@/components/parts/loading';
  import predictivo from '@/components/parts/predictivo';


  Validator.extend('checkiban', {
    validate: value => {
      //TRATAMIENTO DE LA CADENA

      if (!!value) {

        value = value.toUpperCase();
        value = value.trim();
        value = value.replace(/\s/g, "");
        value = value.replace(/[-\/\\^$*+?.()|[\]{}]/g, "");

        var n1, n2;
        var ibanaux;

        n1 = getnumIBAN(value.substring(0, 1));
        n2 = getnumIBAN(value.substring(1, 2));

        ibanaux = String(n1) + String(n2) + value.substring(2);
        ibanaux = ibanaux.substring(6) + ibanaux.substring(0, 6);

        var resto = modulo97(ibanaux);

        return (resto == 1);

      } else {
        return false;
      }

      function getnumIBAN(letra) {
        var ls_letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        return ls_letras.search(letra) + 10;
      }

      function modulo97(iban) {
        var parts = Math.ceil(iban.length / 7);
        var remainer = "";
        for (var i = 1; i <= parts; i++) {
          remainer = String(parseFloat(remainer + iban.substr((i - 1) * 7, 7)) % 97);
        }
        return remainer;
      }

    }
  });

  Validator.extend('checkDNI', {
    validate: dni => {

      let numero, letr, letra;
      let expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

      dni = dni.toUpperCase();

      if (expresion_regular_dni.test(dni) === true) {
        numero = dni.substr(0, dni.length - 1);
        numero = numero.replace('X', 0);
        numero = numero.replace('Y', 1);
        numero = numero.replace('Z', 2);
        letr = dni.substr(dni.length - 1, 1);
        numero = numero % 23;
        letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
        letra = letra.substring(numero, numero + 1);
        return (letra == letr);
      } else {
        return false;
      }

    }
  });



  export default {
    name: 'mi-perfil',
    data() {
      return {
        perfil: '',
        edit: false,
        es: es,
        clicked: false,
        loading: false
      }
    },
    mounted() {
      this.getdata();
      this.requestProvincias();
      this.requestLocalidades();
      this.requestPaises();
    },
    methods: {
      ...mapActions([
        'requestMiPerfil',
        'saveMiPerfil',
        'requestProvincias',
        'requestLocalidades',
        'requestPaises'
      ]),
      getdata() {
        setTimeout(e => {
          this.requestMiPerfil().then(r => {
            this.perfil = r;
          })
        }, 100)
      },
      savedata() {
        this.clicked = true;
        this.$validator.validateAll().then(itsOk => {
          if (itsOk) {
            let fecha = new Date(this.perfil.fechaNacimiento);
            this.perfil.fechaNacimiento = `${fecha.getDate()}/${fecha.getMonth() + 1}/${fecha.getFullYear()}`;
            if(!!this.perfil.iban){
              this.perfil.iban = this.perfil.iban.replace(/[-\/\\^$*+?.()|[\]{}]/g, "");
            }
            this.loading = true;
            this.saveMiPerfil(this.perfil).then(r => {
              this.loading = false;
              this.edit = false;
              this.quitarEspacios();
            });
          }
        });

      },
      eraseObservacion(observacion) {
        this.perfil.observaciones = this.perfil.observaciones.filter(o => o.texto != observacion.texto);
      },
      addObservacion() {
        let fecha = new Date();
        let observacion = {
          texto: '',
          fecha: ''
        };
        observacion.fecha = `${fecha.getDate()}/${fecha.getMonth() + 1}/${fecha.getFullYear()}`;
        this.perfil.observaciones.push(observacion);
      },
      quitarEspacios() {

        if (!!this.perfil.iban) {

          let iban = this.perfil.iban;
          let positions = [4, 9, 14, 17]

          iban = iban.replace(/ /g, "");
          iban = iban.replace(/\t/g, '');

          iban = iban.split("");

          positions.forEach(e => {
            if (iban[e] != '-' && iban.length > e) {
              iban.splice(e, 0, '-');
            }
          });

          iban = iban.join("");

          this.perfil.iban = iban;
        }
      },
      localidadesfilter(provincia) {
        return this.localidades(provincia);
      },
      setProvincia() {
        if (this.perfil.idPais != "1") {
          this.perfil.idProvincia = null;
          this.perfil.provincia = null;
          this.perfil.idLocalidad = null;
          this.perfil.localidad = null;
        }
      },
      localidad(id) {
        return this.getLocalidad(id);
      }
    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        colors: 'basicColors',
        totales: 'getTotales',
        dominios: 'getDominios',
        dominiosOrder: 'getDominiosOrder',
        localidades: 'getLocalidades',
        getLocalidad: 'getLocalidad'
      }),
    },
    components: {
      Datepicker,
      'loading': loading,
      'predictivo': predictivo
    },
    watch: {
      'edit'() {
        this.$validator.reset();
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/views/mi-perfil.vue